<template>
    <div
        class="card"
        :class="{
            'preloader-content': isPreloader,
            'card__hover': isHover
        }"
        @click="onClickCard"
    >
        <div
            v-if="isPreloader"
            class="preloader fa fa-circle-o-notch fa-spin">
        </div>
        <div class="card__title">
            {{title}}
        </div>
        <div class="card__text">
            {{text}}
        </div>
        <div class="card__btn-container">
            <slot name="btnContainer"></slot>
        </div>
        <div class="card__body">
            <slot name="cardBody"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Card',
    /**
     * Входные данные компонента
     * @property {string} title - заголовок
     * @property {string} text - текст
     * @property {boolean} isPreloader - условие отображения прелоадера
     * @property {boolean} isHover - условие срабатывания эффекта hover
     */
    props: {
        title: {
            type: String,
            default: ''
        },
        text: {
            type: String,
            default: ''
        },
        isPreloader: {
            type: Boolean,
            default: false
        },
        isHover: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        /**
         * событие клика по карточке
         */
        onClickCard() {
            this.$emit('onClickCard');
        }
    }
}
</script>

<style lang="scss" scoped>
    .card {
        position: relative;
        margin: 0 10px 10px 0;
        padding: 30px;
        border: 1px solid #eaeaea;
        border-radius: 8px;
        width: 220px;

        background: #fff;
    }
    .card__hover {
        cursor: pointer;
    }
    .card__hover:hover {
        box-shadow: 0 4px 28px rgba(59,74,116,.15), 0 4px 10px rgba(59,74,116,.15);
    }
    .card__title {
        font-size: 14px;
    }
    .card__text {
        color: #a7b0bd;
        margin-top: 10px;
    }
    .card__btn-container {
        margin-top: 10px;
    }
    .card__body {
        margin-top: 10px;
    }
</style>